<template>
  <Layout @layout="e => $emit('layout', e)" :layout="layout" :control_states="control_states" @controlStates="(e) => control_states = e" @letterKey="onLetterKey" @funcKey="onFunctionalKey"/>
</template>

<script>
import Layout from './Layout.vue'

export default {
  props:{
    input: HTMLInputElement,
    layout: Array,
    options: Object
  },
  watch: {},
  data: () => ({
    control_states: {
        shift: false,
        ctrl: false,
        alt: false,
        caps: false
      }
  }),
  methods: {
    dropControlStates() {
      this.control_states = {
        shift: false,
        ctrl: false,
        alt: this.control_states.alt || false,
        caps: this.control_states.caps || false
      }
    },
    onLetterKey(key) {
      this.dropControlStates()
      let caret = this.getCaret()
      let text = this.insertChar(caret, this.input?.value, key)
      this.input.value = text
      this.focusInput(caret)
      this.input.dispatchEvent(new Event("input", { bubbles: true }));
    },
    onFunctionalKey(key) {
      this.dropControlStates()
      let caret = this.getCaret()
      switch(key) {
        case 'backspace':
          this.input.value = this.backspace(caret, this.input?.value)

          this.focusInput(caret)
          break;
        case 'space':
          this.input.value = this.insertChar(caret, this.input?.value, ' ')
          
          if (this.options.capitalized) {
            if (!this.control_states.caps) {
              this.control_states = {...this.control_states, shift: true} 
            }
          }

          this.focusInput(caret)
          break;
        case 'esc':
          this.$emit('exit')
          break;
        case 'tab':
          this.$emit(this.control_states.shift ? 'prev' : 'next')
          break;
        case 'enter':
          if (this.control_states.ctrl) {
            this.insertChar(caret, this.input?.value, '\n')
            this.focusInput(caret)
          } else {
            this.input.closest('form')?.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}))
          }
          this.$emit('exit')
          return;
        default:
          this.focusInput(caret)
      }
      this.input.dispatchEvent(new Event("input", { bubbles: true }));
    },
    backspace(caret, text) {
      // var u = document.createEvent("Event");
      // u.initEvent("keydown", !0, !0)
      // evt.view = document.defaultView;
      let evt = new Event('keydown', {bubbles: true, cancelable: true})
      evt.altKey = this.control_states.alt;
      evt.ctrlKey = this.control_states.ctrl;
      evt.shiftKey = this.control_states.shift;
      evt.metaKey = false;
      evt.key = 'Backspace';
      evt.which = evt.keyCode = 8;
      
      if (this.input.dispatchEvent(evt)) {
        if (caret.start < caret.end) {
          text = text.substring(0, caret.start) + text.substring(caret.end);
        } else {
          text = text.substring(0, caret.start - 1) + text.substring(caret.start);
          caret.start -= 1;
        }
      }

      caret.end = caret.start;
      return text;
    },
    insertChar(caret, text, ch) {
      let evt = new Event('keydown', {bubbles: true, cancelable: true})
      evt.altKey = this.control_states.alt;
      evt.ctrlKey = this.control_states.ctrl;
      evt.shiftKey = this.control_states.shift;
      evt.metaKey = false;
      evt.key = ch;
      evt.which = evt.keyCode = ch.charCodeAt();

      if (this.input.dispatchEvent(evt)) {
        if (caret.start < caret.end) {
          text = text.substring(0, caret.start)  + ch.toString() + text.substring(caret.end);
        } else {
          text = text.substr(0, caret.start) + ch.toString() + text.substr(caret.start);
        }
        caret.start += ch.length;
        caret.end = caret.start;
      }
      
      return text;
    },
    inputSelectable() {
      return ['text', 'password', 'search', 'tel', 'url'].includes(this.input?.type)
    },
    getCaret() {
      if (this.inputSelectable()) {
        let pos = {
          start: this.input.selectionStart || 0,
          end: this.input.selectionEnd || 0
        };
        if (pos.end < pos.start)
          pos.end = pos.start;
        return pos;
      } else {
        let val = this.input.value;
        return {
          start: val.length,
          end: val.length
        };
      }
    },
    focusInput(caret) {
      this.input?.focus();
      setTimeout(() => {
        if (this.options.no_caret) {
          caret = this.getCaret()
        }

        if (caret && this.inputSelectable()) {
          this.input.selectionStart = caret.start;
          this.input.selectionEnd = caret.end;
        }
      }, 100)
      
    }
  },
  computed: {
    numpad(){
      return [
        ['{esc}','{backspace}'],
        [1,2,3, "{+}"],
        [4,5,6, "{-}"],
        [7,8,9, "{*}"],
        [0,'{enter}!!!!!']
      ]
    },
    full_layout(){
      return [
        ['{esc}', 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '-', '+', '{backspace}'],
        ['{tab}', 'q', 'w', 'e', 'r', 't', 'y','u','i','o','p','[',']','\\'],
        ['{caps}','a','s','d','f','g','h','j','k','l',';','\'', '{enter}'],
        ['{shift}','z','x','c','v','b','n','m',',','.','/', '{shift}'],
        ['{ctrl}', '{(@)}','!!!!!!!!!!!!!{space}', '{alt}']
      ]
    },
    ru_kbd(){
      return [
        ['{esc}', 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '-', '+', '{backspace}'],
        ['!{tab}', 'й', 'ц', 'у', 'к', 'е', 'н','г','ш','щ','з','х','ъ','\\'],
        ['!!{caps}','ф','ы','в','а','п','р','о','л','д','ж','э', '{enter}'],
        ['!!!!!{shift}','я','ч','с','м','и','т','ь','б','ю',',', '.', '/', '?'],
        ['{space}']
      ]
    }
  },
  mounted() {
    if (this.input.value == '' && this.options.capitalized) {
      this.control_states.shift = true
    }
  },
  components: {
    Layout
  }
}
</script>